import styled from 'styled-components';
import { PageContainer } from '@dealstack/frontend/shared/layout/PageContainer/PageContainer.tsx';

export const StyledProgrammeSettingsContainer = styled(PageContainer)`
	overflow: hidden;
	position: relative;
	flex-grow: 1;
	flex-shrink: 1;
	flex-basis: 0;
	min-height: 0;
	max-height: 100%;
	display: flex;
	flex-direction: column;
`;
